/**
 * @generated SignedSource<<1d97bcdf0bc2c62b704eb9288873de55>>
 * @relayHash 029e76bfcd70279acd22d488125dc454
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 936914f8502bab28553df0f472fa4f87cbb23cb871cb9a825222f522face951d

import type { ConcreteRequest } from 'relay-runtime';
export type NotificationAction = "DONT_NOTIFY" | "NOTIFY" | "%future added value";
export type Operation = "ASSIGNED" | "COMPLETE" | "DELETED" | "IN_COMPLETE" | "REWORDED" | "UNASSIGNED" | "%future added value";
export type IndividualInlineTaskNotificationInput = {
  notificationAction?: NotificationAction | null;
  operation: Operation;
  recipientAccountId: string;
  recipientMentionLocalId?: string | null;
  taskId: string;
};
export type useCreateInlineTaskNotificationMutationCreateInlineTaskNotificationMutation$variables = {
  contentId: string;
  tasks: ReadonlyArray<IndividualInlineTaskNotificationInput | null>;
};
export type useCreateInlineTaskNotificationMutationCreateInlineTaskNotificationMutation$data = {
  readonly createInlineTaskNotification: {
    readonly contentId: string;
    readonly errors: ReadonlyArray<{
      readonly message: string | null;
    }> | null;
    readonly success: boolean;
  } | null;
};
export type useCreateInlineTaskNotificationMutationCreateInlineTaskNotificationMutation = {
  response: useCreateInlineTaskNotificationMutationCreateInlineTaskNotificationMutation$data;
  variables: useCreateInlineTaskNotificationMutationCreateInlineTaskNotificationMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "tasks"
  }
],
v1 = [
  {
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "contentId",
            "variableName": "contentId"
          },
          {
            "kind": "Variable",
            "name": "tasks",
            "variableName": "tasks"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "CreateInlineTaskNotificationPayload",
    "kind": "LinkedField",
    "name": "createInlineTaskNotification",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "contentId"
      },
      {
        "kind": "ScalarField",
        "name": "success"
      },
      {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "message"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useCreateInlineTaskNotificationMutationCreateInlineTaskNotificationMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useCreateInlineTaskNotificationMutationCreateInlineTaskNotificationMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "029e76bfcd70279acd22d488125dc454",
    "id": "936914f8502bab28553df0f472fa4f87cbb23cb871cb9a825222f522face951d",
    "metadata": {},
    "name": "useCreateInlineTaskNotificationMutationCreateInlineTaskNotificationMutation",
    "operationKind": "mutation",
    "text": "mutation useCreateInlineTaskNotificationMutationCreateInlineTaskNotificationMutation($contentId:ID!,$tasks:[IndividualInlineTaskNotificationInput]!){createInlineTaskNotification(input:{contentId:$contentId,tasks:$tasks}){contentId,success,errors{message}}}"
  }
};
})();

(node as any).hash = "fca74fc99391b016271338a6b81b557d";

export default node;
